import { render } from "./footer-all.vue?vue&type=template&id=09131fcf"
import script from "./footer-all.vue?vue&type=script&lang=js"
export * from "./footer-all.vue?vue&type=script&lang=js"

import "./footer-all.vue?vue&type=style&index=0&id=09131fcf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__